import BasicsSection from './Basics';
import CollidableSection from './Collidable';
import HeroSection from './Hero';
import SortableSection from './Sortable';
import SwappableSection from './Swappable';

const Drag = {
  Basics: BasicsSection,
  Collidable: CollidableSection,
  Hero: HeroSection,
  Sortable: SortableSection,
  Swappable: SwappableSection,
};

export default Drag;
